import { startCase } from 'lodash'

const getCorrectFieldName = (fieldName) => (
  fieldName === 'abartn' ? 'ACH Routing Number' : startCase(fieldName)
)

export default getCorrectFieldName
